/**
 * Enerji modülünü köprü yuvasına taşıma kuralları (sahne koordinatları, 1280×720).
 * Değerlendirme yalnız modül yuva bölgesine bırakıldığında yapılır; dışarı bırakmak cevap sayılmaz.
 */
export const moduleDropRules = {
  /** Bu kadar (sahne pikseli) hareket etmeyen basış "dokunma" sayılır: modül seçilir, yuvaya dokunarak takılır. */
  dragThreshold: 12,
  /** Yuvanın yakalama bölgesi: yuva merkezinden yatay yarı genişlik ve üst sınır; alt sınır sahnenin altı. */
  zoneHalfWidth: 240,
  zoneTop: 415,
  sceneHeight: 720,
  /** Gaz pedalına basılmazsa ipucunun belirme süresi (ms). */
  pedalHintMs: 4000,
} as const;

export type DropPoint = { x: number; y: number };

export function isInDropZone(point: DropPoint, socketX: number): boolean {
  return Math.abs(point.x - socketX) <= moduleDropRules.zoneHalfWidth
    && point.y >= moduleDropRules.zoneTop && point.y <= moduleDropRules.sceneHeight;
}

export function movedBeyondThreshold(start: DropPoint, current: DropPoint): boolean {
  return Math.hypot(current.x - start.x, current.y - start.y) > moduleDropRules.dragThreshold;
}
